<template>
  <div class="chooseCourier">
    <ul>
      <li v-for="(item, index) of list" :key="index" @click="chooseCour(item)">
        <p>
          {{item.name}}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'chooseCourier',
  data () {
    return {
      // id: this.$route.query.id ? this.$route.query.id : '',
      // type: this.$route.query.type ? this.$route.query.type : '',
      title: '',
      courierShow: true,
      list: sessionStorage.getItem('express_list') ? JSON.parse(sessionStorage.getItem('express_list')) : []
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    chooseCour: function (items) {
      this.title = items.name
      this.courierShow = false
      this.$emit('title', this.title)
      this.$emit('courier', this.courierShow)
      // this.$router.replace({
      //   path: '/retsubs',
      //   query: {
      //     id: this.id,
      //     type: this.type,
      //     title: encodeURIComponent(items.name)
      //   }
      // })
    },
    select (index) {
      console.log(index)
    }
  }
}
</script>

<style scoped lang="scss">
  .chooseCourier {
    background: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
    ul {
      background: #fff;
      li {
        color: #333333;
        font-size: 0.17rem;
        font-weight: 400;
        line-height: 0.24rem;
        padding: 0 0.11rem;
        p {
          line-height: 0.24rem;
          padding: 0.12rem 0;
          margin: 0 0.11rem;
          border-bottom: 0.01rem solid #E3E3E3;
        }
        &:active {
          background: rgba(242, 242, 242, 1);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/after/chooseCourier.vue